import { handleActions, combineActions } from 'redux-actions';
import { LOAD_USER_REGISTER } from '../constants';

const intialState = {
  loading: false,
  model: null,
  error: false,
};

const registerReducer = handleActions(
  {
    [LOAD_USER_REGISTER.PENDING]: state => ({
      ...state,
      loading: true,
      error: false,
    }),
    [combineActions(
      LOAD_USER_REGISTER.CANCELLED,
      LOAD_USER_REGISTER.SUCCESS,
      LOAD_USER_REGISTER.ERROR,
    )]: state => ({
      ...state,
      loading: false,
    }),
    [LOAD_USER_REGISTER.SUCCESS]: (state, { payload }) => ({
      ...state,
      model: payload || state.model,
      error: false,
    }),
    [LOAD_USER_REGISTER.ERROR]: (state, { payload }) => {
      return {
        ...state,
        model: payload?.data?.errors?.[0],
        loading: false,
        error: true,
      }
    } ,
  },
  intialState,
);

export default registerReducer;
